import { getPowurUrl } from "~/utils/getUrlForEnvironment"

export const redirectToPowurProjects = (): void => {
  window.location.href = `${getPowurUrl()}/projects/`
}
